import { EXTERNAL_OPERATOR_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';

const Jobs = lazy(() => import('../Jobs'));

const JobsRoutes: RouteObject[] = [
  {
    path: 'jobs',
    element: (
      <Authorize
        permission={[...EXTERNAL_OPERATOR_ROLE_GROUPS.all]}
        fallback={<ErrorPage code={403} />}
      >
        <Jobs />
      </Authorize>
    ),
  },
];

export default JobsRoutes;
